import { WebPlugin } from '@capacitor/core';
export class BarcodeScannerFragmentPluginWeb extends WebPlugin {
    async toggleScanner() {
        return;
    }
    async startScanner() {
        return;
    }
    async stopScanner() {
        return;
    }
    async setIsTorchEnabled() {
        return { isEnabled: true };
    }
    async isScanning() {
        return { isScanning: false };
    }
}
//# sourceMappingURL=web.js.map